














import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Worker, Patient, User, isWorker } from '@/types/user'

@Component({
  components: {
    CheckboxInput: () => import('@/components/common/StyledCheckboxInput.vue')
  }
})
export default class MessageSearchResult extends Vue {
  $store!: ExStore
  @Prop() users!: (Patient | Worker)[]

  get recipients() {
    return this.$store.getters['message/recipients']
  }

  async created() {
    await this.$store.dispatch('team/updatePatients')
  }

  includeRecipients(user: User) {
    return !!this.recipients.find(recipient => recipient.id === user.id)
  }

  getName(user: User) {
    return `${user.lastName}${user.firstName} (${user.lastNameReading}${user.firstNameReading})`
  }

  handleUpdate(checked: boolean, user: Patient | Worker) {
    const action = checked
      ? 'message/addRecipients'
      : 'message/removeRecipients'
    this.$store.dispatch(action, [user])
  }

  getActive(user: Patient | Worker) {
    const worker = this.recipients.find(user => isWorker(user))
    const patient = this.recipients.find(user => !isWorker(user))
    if (isWorker(user)) {
      if (
        patient &&
        !this.$store.getters['team/isPatientsTeam'](patient.id, user.id)
      )
        return false
      if (
        worker &&
        worker.id !== user.id &&
        !this.$store.getters['team/isSameTeam'](worker.id, user.id)
      )
        return false
    } else {
      if (
        worker &&
        !this.$store.getters['team/isPatientsTeam'](user.id, worker.id)
      )
        return false
      if (patient && patient.id !== user.id) return false
    }
    return true
  }
}
